const ENDPOINTS = {
  getAdditionalEmails: (storeId: string) => `/api/additional-emails?storeId=${storeId}`,
  saveAdditionalEmail: () => "/api/additional-emails",
  deleteAdditionalEmail: () => "/api/additional-emails",
};

export { ENDPOINTS };
